import { useState, useEffect } from "react";
import categoryApi, { Category } from "../services/categoryApi";

const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await categoryApi.getCategories();
      setCategories(data);
    } catch (err: any) {
      console.error("useCategories: Error fetching categories:", err);
      console.error("useCategories: Error details:", {
        message: err.message,
        code: err.code,
        status: err.response?.status,
        statusText: err.response?.statusText,
        data: err.response?.data,
      });

      // Provide more specific error messages
      let errorMessage = "שגיאה בטעינת הקטגוריות";
      if (err.code === "ERR_NETWORK") {
        errorMessage = "בעיית חיבור לשרת - בדוק את החיבור לאינטרנט";
      } else if (err.response?.status === 404) {
        errorMessage = "השרת לא נמצא - בדוק שהשרת פועל";
      } else if (err.response?.status >= 500) {
        errorMessage = "שגיאת שרת - נסה שוב מאוחר יותר";
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const refreshCategories = () => {
    fetchCategories();
  };

  return {
    categories,
    loading,
    error,
    refreshCategories,
  };
};

export default useCategories;
